export const version = 'kunde-v1.20.0-SNAPSHOT-6f40e6909f2460315157e5694ab2489ca392aaab';